import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import SubPage from "components/pages/graphic-packing/sub-pages";

const GraphicPackingRoute = ({ graphicPacking, loading, isCreate, history }) => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }/stands` }>
                <SubPage.GraphicChoise
                    graphicPacking={ graphicPacking }
                    loading={ loading }
                    history={ history }
                />
            </Route>
            <Route path={ `${ path }/packed-list` }>
                <SubPage.GraphicStands
                    graphicPacking={ graphicPacking }
                    loading={ loading }
                    history={ history }
                />
            </Route>
            <Route path={ `${ path }` }>
                <SubPage.OverView
                    graphicPacking={ graphicPacking }
                    loading={ loading }
                    isCreate={ isCreate }
                    history={ history }
                />
            </Route>
        </Switch>
    );
};

export default GraphicPackingRoute;